export const SHOW_UI_PARTS = 'hide-ui-parts';
